(() => {
  function init(scope = document) {
    scope.querySelectorAll('[data-gift-select]').forEach(select => {
      if (select.dataset.enhanced) return;
      select.dataset.enhanced = 'true';
      const label = scope.querySelector(`label[for="${select.id}"]`);
      const fieldset = document.createElement('fieldset');
      fieldset.className = 'w-gift-values';
      const legend = document.createElement('legend');
      legend.textContent = label?.textContent || '';
      fieldset.append(legend);
      Array.from(select.options).forEach(option => {
        const choice = document.createElement('label');
        const radio = document.createElement('input');
        radio.type = 'radio'; radio.name = `gift-value-${select.id}`; radio.value = option.value;
        radio.checked = option.selected;
        const text = document.createElement('span'); text.textContent = option.textContent;
        choice.append(radio, text); fieldset.append(choice);
        radio.addEventListener('change', () => { select.value = radio.value; select.dispatchEvent(new Event('change', { bubbles: true })); });
      });
      select.after(fieldset); select.hidden = true; if (label) label.hidden = true;
    });
  }
  document.addEventListener('click', async event => {
    const copy = event.target.closest('[data-gift-copy]');
    if (copy) {
      const code = document.querySelector('[data-gift-code]')?.textContent.replace(/\s/g, '');
      try { await navigator.clipboard.writeText(code); copy.textContent = copy.dataset.copied; } catch { document.getSelection()?.selectAllChildren(document.querySelector('[data-gift-code]')); }
    }
    if (event.target.closest('[data-gift-print]')) window.print();
  });
  document.addEventListener('shopify:section:load', event => init(event.target));
  init();
})();
